import { fetchList } from '@/api/setting/currency'
import { dataToOpts } from '@/utils/opts'
import _ from 'lodash'

const query = {
  limit: 100,
  sort: 'id'
}

const currency = {
  state: {
    inited: false,
    data: [],
    optData: {}
  },

  mutations: {
    INIT_CURRENCY: (state, e) => {
      state.inited = true
      state.data = _.cloneDeep(e.data)
      state.optData = dataToOpts(e.data)
    },
    RESET_CURRENCY: (state) => {
      state.inited = false
    }
  },

  actions: {
    InitCurrency ({ commit }) {
      if (this.state.currency.inited) {
        return new Promise((resolve) => {
          resolve(this.state.currency.optData)
        })
      }
      return new Promise((resolve, reject) => {
        fetchList(query).then(res => {
          commit('INIT_CURRENCY', {
            data: res.data
          })
          resolve(this.state.currency.optData)
        }).catch(() => {
          // do nothing
        })
      })
    },
    ResetCurrency ({ commit }) {
      commit('RESET_CURRENCY')
    }
  }
}

export default currency
